import React, { FC, ReactElement } from 'react'

import './StudentCustomSidebar.scss'

interface IStudentCustomSidebarProps {
  children: ReactElement
  onClose?: () => void
}

const StudentCustomSidebar: FC<IStudentCustomSidebarProps> = ({ children, onClose }) => {
  return (
    <div className="student-custom-sidebar--layout">
      {children}
    </div>
  )
}

export default StudentCustomSidebar
